//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('equipments', {
//        templateUrl: 'views/components/views/equipments/equipments.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'equipmentsService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, equipmentsService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            let variableNames = {
//                searchtext: ''
//            };

//            vm.model = {
//                bgEquipmentsMain: {
//                    selected: 'TOUCH',
//                    buttons: [
//                        { id: 'TOUCH', label: 'bg_equipments_main_touch', color: 'primary', onClick: function () { vm.model.bgEquipmentsMain.selected = 'TOUCH'; } },
//                        { id: 'GRID', label: 'bg_equipments_main_grid', color: 'primary', onClick: function () { vm.model.bgEquipmentsMain.selected = 'GRID'; } }
//                    ]
//                },
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') }
//                ],
//                setting: {},
//                itemsListEquipments: [],
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//    		// #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALLS
            
//            async function loadSetting() {
//                vm.model.setting = (await equipmentsService.getSetting())[0];
//            }

//            async function loadEquipments() {
//                vm.model.itemsListEquipments = await equipmentsService.listEquipments();
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: {}
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region CLEAR FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                };
//            }

//            // #endregion CLEAR FUNCTION

//            // #region BUTTON GROUP SINGLE FUNCTION
            
//            vm.selectBgEquipmentsMain = function (value) {
//                vm.model.bgEquipmentsMain.selected = value;
//            }
            
//    		// #endregion BUTTON GROUP SINGLE FUNCTION

//            // #region ON BLUR MULTI FUNCTION

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                };
//            };

//            // #endregion ON BLUR MULTI FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'equipmentedit':
//                        go({ equipment_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//		    // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadEquipments();
//                loadGrid();
//            }

//		    // #endregion ON INIT FUNCTION
//        }]
//    });
//})();
